import { render, staticRenderFns } from "./CopReport.vue?vue&type=template&id=2503ae1c"
import script from "./CopReport.vue?vue&type=script&lang=js"
export * from "./CopReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports